import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./utils/routes";
import "./index.css";
import "tailwindcss";
import "./App.css";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react"; // ✅ this is the new way

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://c5c0ca7aac79f6e86cdb9506fdf0f9b8@o4510080355926016.ingest.de.sentry.io/4510141356769360",
  integrations: [
    browserTracingIntegration({
      shouldCreateSpanForRequest: (url) => {
        // Explicitly exclude SST domain
        if (url.includes('sst.carsvid.com')) {
          console.log('Excluding SST request from Sentry tracing:', url);
          return false; // No tracing for SST
        }
        // Enable tracing for all other requests
        return true;
      },
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.2,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <Suspense fallback={<></>}>
      <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
        <RouterProvider router={router} />
      </Sentry.ErrorBoundary>
    </Suspense>
  </HelmetProvider>
);
